import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
  Collapse,
} from '@material-ui/core';
// import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import React, { useEffect, useRef, useState } from 'react';
import { appUrl } from '../../../../../utils/config';
import axios from 'axios';
import StyledButton from '../models/Button';
// import OtherInfo from '../updateGrRecord/OtherInfo';
import OtherInfo from './OtherInfo';
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from '../../../containers/actions/types';
import { useDispatch } from 'react-redux';
import FileViewer from '../supplierPOCoAFileViewer/FileViewer';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';
// import OtherInfo from '../models/OtherInfo';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inline: {
    fontSize: '1.35rem',
    display: 'inline',
    fontWeight: 550,
    marginBottom: '0.5rem',
  },
  hrLine: {
    backgroundColor: 'grey',
    width: '2.5rem',
    height: '3px',
    margin: 'inherit',
    marginBottom: '1rem',
    marginTop: '0.25rem',
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: 4,
  },
  staticValue: {
    marginBottom: 16,
    fontSize: '14px',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  hr: {
    marginTop: '1rem',
    marginBottom: '1rem',
    color: 'gray',
    width: '100%',
  },
  grid: {
    paddingBottom: '2rem',
    // paddingTop: '2rem',
  },
}));

const AddNewFile = (props) => {
  const classes = useStyles();
  const errorRef = useRef();
  const dispatch = useDispatch();
  const [openFileView, setOpenFileView] = useState(false);
  const [coaId, setCoAId] = useState(null);
  const {
    GRData,
    POLineRecordDetails,
    onSave,
    asnData,
    setAsnData,
    batchData,
    setBatchData,
    poDetails,
    isAddRecord,
    POBatchRecordDetails,
    setPOBatchRecordDetails,
    handleChange,
    otherFiles,
    setOtherFiles,
    handlingFiles,
    parentHandlingDeleteFile,
    OtherInfoTempNumber,
    handleTempNumber,
    otherInformationRemarks,
    setOtherInformation,
    // coaName,
    errors,
  } = props;
  const [openPo, setOpenPo] = useState(true);
  const [openAsn, setOpenAsn] = useState(true);
  const [openBatch, setOpenBatch] = useState(true);

  const toggleOpen = () => setOpenPo(!openPo);
  const toggleOpenBatch = () => setOpenBatch(!openBatch);
  const toggleOpenAsn = () => setOpenAsn(!openAsn);

  // const POBatchRecordDetails = poDetails?.GRDetails?.POBatchRecordDetails
  //   ?.otherInformationRemarks
  //   ? poDetails?.GRDetails?.POBatchRecordDetails?.otherInformationRemarks
  //   : 'NA';

  // map data from poDetails to local state
  useEffect(() => {
    if (poDetails) {
      setPOBatchRecordDetails(poDetails?.GRDetails?.POBatchRecordDetails);
    }
  }, [poDetails]);

  useEffect(() => {
    if (poDetails) {
      const { GRDetails } = poDetails;
      const {
        challanInformation,
        invoiceInformation,
        asnDetails,
        POBatchRecordDetails,
      } = GRDetails;

      setAsnData({
        ...asnDetails,
        asnNumber: asnDetails?.asnNumber,
        asnDocumentDate: asnDetails.asnLastModifiedDate
          ? new Date(asnDetails?.asnLastModifiedDate.split('T')[0])
              .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
              .replace(/ /g, '-')
              .toUpperCase()
          : '-NA-',
        asnScheduleDeliveryDate: asnDetails?.asnDeliveryDate
          ? new Date(asnDetails?.asnDeliveryDate.split('T')[0])
              .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
              .replace(/ /g, '-')
              .toUpperCase()
          : '-NA-',
        ewayBillNumber: challanInformation.ewayBillNumber,
        ewayBillDate: challanInformation.ewayBillDate
          ? new Date(challanInformation?.ewayBillDate.split('T')[0])
              .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
              .replace(/ /g, '-')
              .toUpperCase()
          : '-NA-',
        boeNumber: asnDetails?.asnBoENO || '-NA-',
        boeDate: asnDetails?.asnBoEIDDate
          ? new Date(asnDetails?.asnBoEIDDate.split('T')[0])
              .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
              .replace(/ /g, '-')
              .toUpperCase()
          : '-NA-',
        lorryReceiptNumber: POBatchRecordDetails.lorryReceiptNumber || '',
        transporterName: POBatchRecordDetails.transporterName || '',
        invoiceNumber: invoiceInformation.invoiceNumber || '',
        invoiceDate: invoiceInformation.invoiceDate
          ? invoiceInformation.invoiceDate.split('T')[0]
          : // ? new Date(invoiceInformation.invoiceDate.split('T')[0])
            //     .toLocaleDateString('en-GB', {
            //       day: '2-digit',
            //       month: 'short',
            //       year: 'numeric',
            //     })
            //     .replace(/ /g, '-')
            //     .toUpperCase()
            '',
        // invoiceDate: invoiceInformation.invoiceDate
        //   ? (() => {
        //       const date = new Date(invoiceInformation.invoiceDate);
        //       const day = String(date.getDate()).padStart(2, '0');
        //       const month = date.toLocaleString('en-GB', { month: 'short' });
        //       const year = date.getFullYear();
        //       return `${day}-${month}-${year}`;
        //     })()
        //   : '',

        challanNumber: challanInformation.challanNumber || '',
        challanDate: challanInformation.challanDate
          ? challanInformation.challanDate.split('T')[0]
          : '',
        vehicleNumberSupplier: asnDetails?.vehicleNumberSupplier,
        vehicleNumberCMO: challanInformation?.VehicleNumberCMO || '',
        coaDocumentID: asnDetails?.coaDocumentID || null,
        //  (doubt)
      });
    }
  }, [poDetails]);

  useEffect(() => {
    if (poDetails) {
      setBatchData({
        asnUOM: poDetails?.GRDetails?.asnDetails?.asnUOM,
        // analyticalReportNumber:
        //   poDetails?.GRDetails?.qualityAssuranceInfo?.analyticalReportNumber ||
        //   '',
        batchNumberQA:
          poDetails?.GRDetails?.qualityAssuranceInfo?.batchNumberQA || '',
        numberMRN: poDetails?.GRDetails?.POBatchRecordDetails?.numberMRN || '',
        asnBatchQuantity: poDetails?.GRDetails?.asnDetails?.asnBatchQuantity,
        // (doubt)
        actualQuantityReceived: poDetails?.GRDetails?.asnDetails
          ?.asnBatchQuantity
          ? poDetails?.GRDetails?.asnDetails?.asnBatchQuantity
          : poDetails?.GRDetails?.receivedQuantityInfo?.actualQuantityReceived,
        materialReceivedDate:
          poDetails?.GRDetails?.POBatchRecordDetails?.materialReceivedDate,
        expirationDate: poDetails?.GRDetails?.qualityAssuranceInfo
          ?.expirationDate
          ? poDetails?.GRDetails?.qualityAssuranceInfo?.expirationDate.split(
              'T'
            )[0]
          : '',
        materialManufactureDate: poDetails?.GRDetails?.qualityAssuranceInfo
          ?.materialManufactureDate
          ? poDetails?.GRDetails?.qualityAssuranceInfo?.materialManufactureDate.split(
              'T'
            )[0]
          : // ? new Date(
            //     poDetails?.GRDetails?.qualityAssuranceInfo?.materialManufactureDate.split(
            //       'T'
            //     )[0]
            //   )
            //     .toLocaleDateString('en-GB', {
            //       day: '2-digit',
            //       month: 'short',
            //       year: 'numeric',
            //     })
            //     .replace(/ /g, '-')
            //     .toUpperCase()
            '',
      });
    }
  }, [poDetails]);

  const scrollToTop = () => {
    setTimeout(
      () =>
        errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' }),
      100
    );
  };

  useEffect(() => {
    if (errors.errorFields.length > 0 && errors.errorTitle !== '') {
      scrollToTop();
    }
  }, [errors]);

  const handleAsnChange = (e) => {
    const { name, value } = e.target;
    setAsnData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBatchChange = (e) => {
    const { name, value } = e.target;
    setBatchData((prev) => ({ ...prev, [name]: value }));
  };

  // const formatToInputDate = (dateStr) => {
  //   if (!dateStr) return '';
  //   return new Date(dateStr.replace(/-/g, ' ')).toISOString().split('T')[0];
  // };

  // const handleChange =(e)=>{

  const handleDownload = (Id) => {
    if (Id) {
      let backdropText = 'Downloading, Please Wait...';
      dispatch({
        type: OPEN_BACKDROP,
        backdropText,
      });
      // axios
      //   .get(
      //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getCOADetails/download/${Id}`
      //   )
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadGRFiles`,
          { schrockenGRFileId: Id }
        )
        .then((res) => {
          if (res.data.status) {
            let fileDataArray = res.data.fileData.data;
            var byteArray = new Uint8Array(fileDataArray);

            var a = window.document.createElement('a');

            a.href = window.URL.createObjectURL(
              new Blob([byteArray], { type: 'application/octet-stream' })
            );
            a.download = res.data.fileName;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
          dispatch({
            type: DESTROY_BACKDROP,
          });
        })
        .catch((err) => {
          console.log(err);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        });
    }
  };

  return (
    <>
      <div
        style={{
          width: '60vw',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          marginLeft: '22vw',
          marginRight: '22vw',
        }}
      >
        {errors.errorFields.length > 0 && errors.errorTitle !== '' && (
          <Grid
            container
            ref={(el) => {
              errorRef.current = el;
            }}
            justifyContent='center'
            style={{
              padding: '1rem 0',
              // display: error.errorMessage === null && 'none',
            }}
          >
            <Grid item xs={6}>
              <Typography
                variant='h6'
                style={{
                  border: '1px solid #FF0000',
                  backgroundColor: '#FFF0F0',
                  opacity: '1',
                  textAlign: 'center',
                  padding: '0.8rem',
                  fontSize: '0.875rem',
                }}
              >
                {errors.errorTitle}
              </Typography>
            </Grid>
          </Grid>
        )}
        {/* Header with arrow */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            cursor: 'pointer',
          }}
          onClick={toggleOpen}
        >
          <IconButton size='small'>
            {openPo ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
          <div>
            <Typography
              variant='body1'
              style={{ fontWeight: 600, fontSize: '1.5rem' }}
            >
              PO Details
            </Typography>
            <hr className={classes.hrLine} />
          </div>
        </div>

        <Collapse in={openPo} timeout='200'>
          <Grid container spacing={3}>
            {/* Row 1 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                PO / STO Number
              </Typography>
              <Typography>
                {POLineRecordDetails?.supplierPurchaseOrderNumber || 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                PO Date
              </Typography>
              <Typography>
                {POLineRecordDetails?.supplierPODate
                  ? presentFormatedData(
                      new Date(
                        POLineRecordDetails?.supplierPODate.split('T')[0]
                      )
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Sch Delivery Date
              </Typography>
              <Typography>
                {POLineRecordDetails?.scheduledDeliveryDate
                  ? presentFormatedData(
                      new Date(
                        POLineRecordDetails?.scheduledDeliveryDate.split('T')[0]
                      )
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>

            {/* Row 2 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Material Type
              </Typography>
              <Typography>
                {POLineRecordDetails?.materialType || 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Material Name / Description
              </Typography>
              <Typography>
                {POLineRecordDetails?.materialName || 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Code
              </Typography>
              <Typography>
                {POLineRecordDetails?.materialCode || 'NA'}
              </Typography>
            </Grid>

            {/* Row 3 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                UOM
              </Typography>
              <Typography>
                {POLineRecordDetails?.unitOfMeasurementOrdered || 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Quantity
              </Typography>
              <Typography>
                {POLineRecordDetails?.quantityOrdered || 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Delivery Tolerance
              </Typography>
              <Typography>
                {POLineRecordDetails?.overDeliveryTolerance || 'NA'}
              </Typography>
            </Grid>

            {/* Row 4 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Shelf Life
              </Typography>
              <Typography>
                {POLineRecordDetails?.minShelfLife}{' '}
                {POLineRecordDetails?.shelfLifeUnitIndicator || 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Supplier Name
              </Typography>
              <Typography>
                {POLineRecordDetails?.supplierName || 'NA'}
              </Typography>
            </Grid>
            {/* <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Batch Status
              </Typography>
              <Typography>{GRData?.batchStatusText}</Typography>
            </Grid> */}
            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>
          </Grid>
        </Collapse>

        <hr className={classes.hr} />

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            cursor: 'pointer',
          }}
          onClick={toggleOpenAsn}
        >
          <IconButton size='small'>
            {openAsn ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
          <div>
            <Typography
              variant='body1'
              style={{ fontWeight: 600, fontSize: '1.5rem' }}
            >
              ASN / GRN Input Details
            </Typography>
            <hr className={classes.hrLine} />
          </div>
        </div>
        <Collapse in={openAsn} timeout='200'>
          <Grid container spacing={3}>
            {/* Row 1 — 3 columns */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                ASN Number
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData.asnNumber || 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                ASN Document Date
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData.asnDocumentDate || 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                ASN Schedule Delivery Date
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData.asnScheduleDeliveryDate || 'NA'}
              </Typography>
            </Grid>

            {/* Row 2 — 2 columns aligned under first two columns */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                E-way Bill No.
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData.ewayBillNumber || 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                E-way Bill Date
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData.ewayBillDate || 'NA'}
              </Typography>
            </Grid>

            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>

            {/* Row 3 — 2 columns */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>BoE No.</Typography>
              <Typography className={classes.staticValue}>
                {asnData.boeNumber || 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>BoE Date</Typography>
              <Typography className={classes.staticValue}>
                {asnData.boeDate || 'NA'}
              </Typography>
            </Grid>

            {/* Empty column for alignment */}
            <Grid item xs={12} sm={4}></Grid>

            {/* Editable Fields (2-column layout) */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Lorry Receipt (LR) Number{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                placeholder='Enter LR Number...'
                variant='outlined'
                name='lorryReceiptNumber'
                value={asnData.lorryReceiptNumber}
                onChange={handleAsnChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('lorryReceiptNumber')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('lorryReceiptNumber')
                    ? 'Enter LR Number.'
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Transporter Name <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Transporter Name...'
                name='transporterName'
                value={asnData.transporterName}
                onChange={handleAsnChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('transporterName')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('transporterName')
                    ? 'Enter Transporter Name.'
                    : ''
                }
              />
            </Grid>

            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Invoice Number <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Invoice Number...'
                name='invoiceNumber'
                value={asnData.invoiceNumber}
                onChange={handleAsnChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('invoiceNumber')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('invoiceNumber')
                    ? 'Enter invoice number.'
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Invoice Date <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                variant='outlined'
                size='small'
                type='date'
                placeholder='Enter Invoice Date...'
                name='invoiceDate'
                InputLabelProps={{ shrink: true }}
                value={asnData.invoiceDate}
                onChange={handleAsnChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('invoiceDate')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('invoiceDate')
                    ? 'Enter invoice date.'
                    : ''
                }
              />
            </Grid>

            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Challan Number
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                name='challanNumber'
                placeholder='Enter challan Number...'
                value={asnData.challanNumber}
                onChange={handleAsnChange}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Challan Date
              </Typography>
              <TextField
                // fullWidth
                variant='outlined'
                type='date'
                size='small'
                placeholder='Enter challan Date...'
                name='challanDate'
                InputLabelProps={{ shrink: true }}
                value={asnData.challanDate}
                onChange={handleAsnChange}
              />
            </Grid>

            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Vehicle Number (Supplier)
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Vehicle Number(supplier)...'
                name='vehicleNumberSupplier'
                value={asnData.vehicleNumberSupplier}
                onChange={handleAsnChange}
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Vehicle Number (CMO)
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Vehicle Number(CMO)...'
                name='vehicleNumberCMO'
                value={asnData.vehicleNumberCMO}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only alphanumeric, dash, and space, and max 15 chars
                  const regex = /^[A-Za-z0-9\- ]{0,15}$/;

                  if (regex.test(value)) {
                    handleAsnChange(e);
                  }
                }}
                inputProps={{
                  maxLength: 15, // extra safeguard for input length
                }}
              />
            </Grid>

            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12}>
              <Typography className={classes.sectionTitle}>CoA</Typography>
              {/* {asnData.coaDocumentID ? (
                <Typography
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  // onClick={() => handleDownload(asnData?.coaDocumentID)}
                  onClick={() => setOpenFileView(true)}
                >
                  {coaName}
                </Typography>
              ) : (
                <Typography className={classes.staticValue}>NA</Typography>
              )} */}
              {Array.isArray(asnData.COAFiles) &&
              asnData.COAFiles.length > 0 ? (
                asnData.COAFiles.map((val) => {
                  return (
                    <Typography
                      style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                      // onClick={() => handleDownload(asnData?.coaDocumentID)}
                      onClick={() => {
                        setCoAId(val.schrockenGRFileId);
                        setOpenFileView(true);
                      }}
                    >
                      {val.grFileName}
                    </Typography>
                  );
                })
              ) : (
                <Typography className={classes.staticValue}>NA</Typography>
              )}
            </Grid>
            <FileViewer
              fileId={coaId}
              openFileView={openFileView}
              handleFileViewClose={() => setOpenFileView(false)}
              downloadFile={handleDownload}
            />
          </Grid>
        </Collapse>

        <hr className={classes.hr} />

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            cursor: 'pointer',
          }}
          onClick={toggleOpenBatch}
        >
          <IconButton size='small'>
            {openBatch ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
          <div>
            <Typography
              variant='body1'
              style={{ fontWeight: 600, fontSize: '1.5rem' }}
            >
              Batch Details
            </Typography>
            <hr className={classes.hrLine} />
          </div>
        </div>

        <Collapse in={openBatch} timeout='200'>
          <Grid container spacing={3}>
            {/* Row 1 */}
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                {/* Analytical Report (AR) Number */}
                Supplier Batch Number
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                disabled={asnData.asnNumber ? true : false}
                size='small'
                variant='outlined'
                placeholder='Enter Supplier Batch Number...'
                name='batchNumberQA'
                value={batchData.batchNumberQA}
                onChange={handleBatchChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('batchNumberQA')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('batchNumberQA')
                    ? 'Enter Supplier Batch no.'
                    : ''
                }
              />
              {/* <TextField
                // fullWidth
                disabled={asnData.asnNumber ? true : false}
                size='small'
                variant='outlined'
                placeholder='Enter Supplier Batch Number...'
                name='analyticalReportNumber'
                value={batchData.analyticalReportNumber}
                onChange={handleBatchChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('analyticalReportNumber')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('analyticalReportNumber')
                    ? 'Enter Supplier Batch no.'
                    : ''
                }
              /> */}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Enter MRN Number <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter MRN Number...'
                name='numberMRN'
                value={batchData.numberMRN}
                onChange={handleBatchChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('numberMRN')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('numberMRN')
                    ? 'Enter MRN no.'
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={4}></Grid>
            {/* Row 2 */}
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                ASN Batch Quantity
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter ASN Batch qty...'
                name='asnBatchQuantity'
                value={batchData.asnBatchQuantity}
                onChange={handleBatchChange}
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Enter Actual Quantity Received{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Actual Quantity...'
                name='actualQuantityReceived'
                value={batchData.actualQuantityReceived}
                onChange={handleBatchChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                }}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('actualQuantityReceived')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('actualQuantityReceived')
                    ? 'Enter Actual Quantity Received.'
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>UOM</Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='UOM...'
                name='asnUOM'
                value={batchData?.asnUOM}
                onChange={handleBatchChange}
                disabled
              />
            </Grid>
            {/* Row 3 */}
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Enter Quantity Received Date{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Quantity Received Date...'
                type='date'
                name='materialReceivedDate'
                InputLabelProps={{ shrink: true }}
                value={batchData.materialReceivedDate}
                onChange={handleBatchChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('materialReceivedDate')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('materialReceivedDate')
                    ? 'Enter Quantity Received Date'
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Date of Expiration <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter Date of Expiration...'
                type='date'
                name='expirationDate'
                InputLabelProps={{ shrink: true }}
                value={batchData.expirationDate}
                onChange={handleBatchChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('expirationDate')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('expirationDate')
                    ? 'Enter Expiration Date'
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Date of Manufacturing <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                // fullWidth
                size='small'
                variant='outlined'
                type='date'
                placeholder='Enter Date of Manufacturing...'
                name='materialManufactureDate'
                InputLabelProps={{ shrink: true }}
                value={batchData.materialManufactureDate}
                onChange={handleBatchChange}
                error={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('materialManufactureDate')
                }
                helperText={
                  Array.isArray(errors.errorFields) &&
                  errors.errorFields.includes('materialManufactureDate')
                    ? 'Enter Manufacture Date'
                    : ''
                }
              />
            </Grid>
          </Grid>
        </Collapse>

        <hr className={classes.hr} />
        <Grid item xs={12} sm={6} md={6}>
          <Typography
            variant='body1'
            style={{ fontWeight: 600, fontSize: '1.5rem' }}
          >
            Other Information
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>

        <OtherInfo
          isAddRecord={true}
          POBatchRecordDetails={POBatchRecordDetails}
          handleAsnChange={handleAsnChange}
          handlingFiles={handlingFiles}
          //parent
          parentHandlingDeleteFile={parentHandlingDeleteFile}
          //appending file
          OtherInfoTempNumber={OtherInfoTempNumber}
          handleTempNumber={handleTempNumber}
          otherFiles={otherFiles}
          setOtherFiles={setOtherFiles}
          otherInformationRemarks={otherInformationRemarks}
          setOtherInformation={setOtherInformation}
        />

        {/* <Button variant='contained' color='primary' onClick={onSave}>
          Save
        </Button> */}
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2rem',
          }}
          item
          xs={12}
          sm={12}
        >
          <React.Fragment>
            <StyledButton
              // size='small'
              onClick={onSave}
              style={{
                paddingLeft: '4rem',
                paddingRight: '4rem',
              }}
            >
              Next
            </StyledButton>
          </React.Fragment>
        </Grid>

        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
          item
          xs={12}
          sm={12}
          // className={classes.clear}
        >
          <Typography
            variant='caption'
            // onClick={this.handleClearData}
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              paddingTop: '2rem',
            }}
          >
            Clear all Data
          </Typography>
        </Grid>
      </div>
    </>
  );
};

export default AddNewFile;
